import { render, staticRenderFns } from "./CardPremium.vue?vue&type=template&id=b36e4f1e&scoped=true"
import script from "./CardPremium.vue?vue&type=script&lang=js"
export * from "./CardPremium.vue?vue&type=script&lang=js"
import style0 from "./CardPremium.vue?vue&type=style&index=0&id=b36e4f1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36e4f1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/build/components/BaseButton.vue').default,Card: require('/build/components/Card.vue').default})
